import React from 'react';
import { motion } from 'framer-motion';
import { AtomIcon, BookOpenIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} tomos premium`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} bonos estratégicos`
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="tech-grid relative isolate overflow-hidden bg-blue-950" data-id="element-110" data-mp="sarsclmrys9u">
      <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-111" data-mp="ncgl8inv6vvb" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-112" data-mp="neaw145f97lo">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-md border border-slate-300/40 bg-blue-900 px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-slate-200" data-id="element-113" data-mp="3d2tp5bt8kofl">
          <AtomIcon className="h-4 w-4" aria-hidden="true" data-id="element-114" data-mp="39autvl4lu10x" /> Megapack Energía Nuclear Listo
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.05] text-white sm:text-5xl lg:text-6xl" data-id="element-115" data-mp="3e8efj63mtg2w">
          Todo tu año de Energía Nuclear
          <br data-id="element-116" data-mp="2viy4vpy8g78r" />
          <span className="silver-text" data-id="element-117" data-mp="2viewazuh2v7e">resuelto en una tarde.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-118" data-mp="2hjf7ns6ymgb8">
          <img src={productImage} alt="Megapack Energía Nuclear Listo: nueve tomos y cinco bonos sobre fundamentos, radiactividad, fisión, reactores, seguridad nuclear, residuos, aplicaciones, sostenibilidad y enseñanza" className="mx-auto w-full rounded-xl" data-id="element-119" data-mp="s3mahuslbkuo" />
        </motion.div>

        <div className="mt-9" data-id="element-120" data-mp="dbar95zzdixx">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-121" data-mp="1b1fez1iv42u6">
            Quiero mi Megapack ahora
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-slate-100" data-id="element-122" data-mp="162m47guympxp">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-md border border-slate-300/30 bg-blue-900 px-3 py-2" data-id="element-123" data-mp="x1w7maxvkvix">
              <Icon className="h-3.5 w-3.5 text-slate-300" aria-hidden="true" data-id="element-124" data-mp="3hrlmgnykwhbm" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}